module.exports = __webpack_public_path__ + "static/img/areaA-34.2176e8e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/areaA-34.png
// module id = 978
// module chunks = 1